import { render, staticRenderFns } from "./AddUserWizard.vue?vue&type=template&id=08bdb2fe&scoped=true"
import script from "./AddUserWizard.vue?vue&type=script&lang=js"
export * from "./AddUserWizard.vue?vue&type=script&lang=js"
import style0 from "./AddUserWizard.vue?vue&type=style&index=0&id=08bdb2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bdb2fe",
  null
  
)

export default component.exports